import { render, staticRenderFns } from "./compraMaterialesIndex.vue?vue&type=template&id=4ad0842a&scoped=true&"
import script from "./compraMaterialesIndex.vue?vue&type=script&lang=ts&"
export * from "./compraMaterialesIndex.vue?vue&type=script&lang=ts&"
import style0 from "./compraMaterialesIndex.vue?vue&type=style&index=0&id=4ad0842a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0842a",
  null
  
)

export default component.exports